export enum JobsCleverTapEvents {
  webJobsCreatePageView = 'Web_Jobs_Create_Page_View',
  webCreateCustomerPageView = 'Web_Create_Customer_Page_View',
  webServiceAddressPageView = 'Web_Service_Address_Page_View',
  webJobsLeadSourcePageView = 'Web_Jobs_Lead_Source_Page_View',
  webJobsSchedulePageView = 'Web_Jobs_Schedule_Page_View',
  webAddTeamMemberPageView = 'Web_Add_Team_Member_Page_View',
  webJobDescriptionPageView = 'Web_Job_Description_Page_View',
  webJobsEditPageView = 'Web_Jobs_Edit_Page_View',
  webEnterNotesTextBoxClicked = 'Web_Enter_Notes_Text_Box_Clicked',
  webCreateNotePage = 'Web_Create_Note_Page',
  webJobHistoryPanel = 'Web_Job_History_Panel',
  webImageViewerOpened = 'Web_Image_Viewer_Opened',
  webDeleteJobConfirmation = 'Web_Delete_Job_Confirmation',
  webAttachmentLibraryOpened = 'Web_Attachment_Library_Opened',
  webJobAutofillFieldEdited = 'Web_Job_Autofill_Field_Edited',
  webJobCreatedAfterAutofill = 'Web_Job_Created_After_Autofill',
  webJobCreatedManually = 'Web_Job_Created_Manually',
  webDuplicateJob = 'Web_Duplicate_Job'
}
